import {KnightState, MechanicKnightState, MechanicPirateState, MechanicRobberState, PlayerColor} from '@colonist/game-states'
import {MapValidator} from '../core/map/MapValidator'
import {PlayerValidator} from '../core/PlayerValidator'
import {MechanicValidator} from './MechanicValidator'
import {MechanicValidatorKnight} from './MechanicValidatorKnight'
import {ActionStatus} from '@colonist/game-base-types'

export class MechanicValidatorKnightActions extends MechanicValidator {
    private readonly knightValidator: MechanicValidatorKnight
    private readonly robberState: MechanicRobberState | undefined
    private readonly pirateState: MechanicPirateState | undefined

    constructor(playerValidators: PlayerValidator[], mapValidator: MapValidator, knightState: MechanicKnightState, robberState: MechanicRobberState | undefined, pirateState: MechanicPirateState | undefined) {
        super(playerValidators, mapValidator)

        this.knightValidator = new MechanicValidatorKnight(playerValidators, mapValidator, knightState)
        this.robberState = robberState
        this.pirateState = pirateState
    }

    canPlayerTakeKnightAction(player: PlayerColor): ActionStatus {
        const knightLocationsEligibleForActions = this.getAllKnightLocationsEligibleForActions(player)
        if(knightLocationsEligibleForActions.length <= 0) return {canTakeAction: false, errorMessageIfCantTakeAction: {key: 'strings:game.errors.noKnightsForAction'}, validHoverLocations: knightLocationsEligibleForActions}

        return {canTakeAction: true, validHoverLocations: knightLocationsEligibleForActions}
    }

    getAllKnightLocationsEligibleForActions(player: PlayerColor): number[] {
        const knightsThatPlayerCanMove = this.getKnightLocationsPlayerCanMove(player)
        const knightsThatCanDisplaceTheRobberOrPirate = this.getKnightLocationsThatCanChaseAwayTheRobberOrPirate(player)

        return [...knightsThatPlayerCanMove, ...knightsThatCanDisplaceTheRobberOrPirate]
    }

    private getKnightLocationsPlayerCanMove(player: PlayerColor): number[] {
        const knightPlayerValidator = this.knightValidator.getKnightPlayerValidator(player)
        const knightLocationsThatCanBeMoved: number[] = []
        for(const knight of knightPlayerValidator.getKnightStates()) {
            if(!knight.isActivated) continue
            if(knight.locationCornerIndex == undefined) continue
            if(knight.isActivatedThisTurn) continue

            const includeKnightDisplacement = true
            const whereCanPlayerMoveKnight = this.knightValidator.whereCanPlayerMoveKnight(knight, player, includeKnightDisplacement)
            const doesPlayerHaveSomewhereToMoveKnight = whereCanPlayerMoveKnight.length > 0
            if(!doesPlayerHaveSomewhereToMoveKnight) continue

            knightLocationsThatCanBeMoved.push(knight.locationCornerIndex)
        }
        return knightLocationsThatCanBeMoved
    }

    private getKnightLocationsThatCanChaseAwayTheRobberOrPirate(player: PlayerColor): number[] {
        const knightPlayerValidator = this.knightValidator.getKnightPlayerValidator(player)
        const knightsThatCanChaseAwayTheRobber: number[] = []
        for(const knight of knightPlayerValidator.getKnightStates()) {
            if(!knight.isActivated) continue
            if(knight.locationCornerIndex == undefined) continue
            if(knight.isActivatedThisTurn) continue

            const whereCanKnightChaseAwayRobberOrPirate = this.whereCanKnightChaseAwayRobberOrPirate(knight)
            if(whereCanKnightChaseAwayRobberOrPirate.length <= 0) continue

            knightsThatCanChaseAwayTheRobber.push(knight.locationCornerIndex)
        }
        return knightsThatCanChaseAwayTheRobber
    }

    whereCanKnightChaseAwayRobberOrPirate(knightState: KnightState): number[] {
        if(knightState.locationCornerIndex == undefined) return []
        const tileCorner = this.mapValidator.tileState.tileCorners[knightState.locationCornerIndex]

        const whereCanPlayerChaseAwayRobberOrPirate: number[] = []
        for(const touchingFace of tileCorner.hexCorner.touchingFaces()) {
            const tileHex = this.mapValidator.tileState.getTileHex(touchingFace)
            if(tileHex == undefined) continue

            const tileIndex = this.mapValidator.tileState.getTileHexIndex(tileHex.hexFace)
            if(tileIndex == undefined) continue

            if(this.robberState?.isActive == true && this.robberState?.locationTileIndex == tileIndex) whereCanPlayerChaseAwayRobberOrPirate.push(tileIndex)
            if(this.pirateState?.isActive == true && this.pirateState?.locationTileIndex == tileIndex) whereCanPlayerChaseAwayRobberOrPirate.push(tileIndex)
        }
        return whereCanPlayerChaseAwayRobberOrPirate
    }
}
